import React from 'react';
import doctorImage from '../Assets/doctor.png';
import skinTypeImage from '../Assets/skinType.png';
import preCareImage from '../Assets/pre-care.jpg';
import afterCareImage from '../Assets/post-care.jpg';
import useSiteContent from '../hooks/useSiteContent';
import TreatmentPage from './TreatmentPage';

export default function BrowsPage() {
  const { siteContent } = useSiteContent();

  return (
    <TreatmentPage
      pageContent={siteContent.brows}
      candidateImage={doctorImage}
      candidateAlt="Brow treatment details"
      cautionImage={skinTypeImage}
      cautionAlt="Brow treatment caution"
      beforeImage={preCareImage}
      beforeAlt="Before brow treatment care"
      afterImage={afterCareImage}
      afterAlt="After brow treatment care"
      ctaTo="/pricing"
      ctaLabel={siteContent.common.pricing}
    />
  );
}
